import React from "react";
import { format } from "date-fns";

const ReportContent = ({ data, detailed, tableColumns }) => {
    const columns = [
        { id: "id", className: "w-[5%]", render: (item) => item.code },
        { id: "camera", className: "w-[50%]", render: (item) => item.description },
        { id: "position", className: "w-[10%]", render: (item) => item.position },
        { id: "sla", className: "w-[10%]", render: (item) => item.sla_on },
        { id: "inactive", className: "w-[33%]", render: (item) => item.sla_off },
        { id: "events", className: "w-[11%]", render: (item) => item.events?.length ?? "" },
    ];
    const visibleColumns = columns.filter(
        (column) => tableColumns?.[column.id]?.visible !== false,
    );

    return visibleColumns.length ? (
        <table id="sla-cameras-data" className="table report-table export-data" sheet-name="SLA de câmeras">
            <thead className="thead-background">
                <tr className="bg-[#f6f6f6] text-left">
                    {visibleColumns.map((column) => (
                        <th key={column.id} className={column.className}>
                            {tableColumns[column.id].label}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {data.map((item, index) => (
                    <React.Fragment key={index}>
                        <tr className={`table-break-word ${detailed ? "details-row" : ""}`}>
                            {visibleColumns.map((column) => (
                                <td key={column.id}>{column.render(item)}</td>
                            ))}
                        </tr>

                        {detailed && item.events?.length > 0 && (
                            <tr>
                                <td colSpan={visibleColumns.length}>
                                    <div className="!px-9">
                                        <table>
                                            <thead>
                                                <tr className="!bg-[#f6f6f6] text-left">
                                                    <th className="text-start">D/H de início</th>
                                                    <th className="text-center">D/H de fim</th>
                                                    <th className="text-end">Duração do evento</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {item.events.map((event, eventIndex) => (
                                                    <tr key={eventIndex} className="table-break-word">
                                                        <td className="text-start">{event.dt_begin ? format(event.dt_begin, "dd/MM/yyyy HH:mm") : ""}</td>
                                                        <td className="text-center">{event.dt_end ? format(event.dt_end, "dd/MM/yyyy HH:mm") : ""}</td>
                                                        <td className="text-end">{event.duration}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </React.Fragment>
                ))}
            </tbody>
        </table>
    ) : (
            <div id="noDataMessage" className="alert alert-info p-2 h6 text-center">
            Todas as colunas foram ocultadas.
        </div>
    );
};

export default ReportContent;